import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text"]

  connect() {
    this.fitText()
  }

  fitText() {
    const el = this.textTarget
    const card = this.element.closest(".czn-card")
    const maxHeight = card.offsetHeight * 0.45
    let size = 1.0

    el.style.fontSize = `${size}em`

    while (el.scrollHeight > maxHeight && size > 0.7) {
      size -= 0.05
      el.style.fontSize = `${size}em`
    }
  }
}
